import { RefObject, useCallback, useEffect } from "react";
import { IBrushSettings } from "../../models/brush.ts";
import { useBrushCore } from "./useBrushCore.tsx";

export const useBrushOnCanvas = (
	brushConfig: IBrushSettings,
	canvasRef: RefObject<HTMLCanvasElement | null>,
	brushingAreaCanvasRef: RefObject<HTMLCanvasElement | null>,
	cursorRef: RefObject<HTMLDivElement | null>,
) => {
	const clearBrushOverlayCanvasRef = useCallback(() => {
		if (brushingAreaCanvasRef.current && brushingAreaCanvasRef.current.getContext) {
			const context = brushingAreaCanvasRef.current.getContext("2d");
			if (context) {
				context.clearRect(0, 0, brushingAreaCanvasRef.current.width, brushingAreaCanvasRef.current.height);
			}
		}
	}, [brushingAreaCanvasRef]);

	useEffect(() => {
		clearBrushOverlayCanvasRef();
	}, [brushConfig]);

	const { captureMask, restoreMask } = useBrushCore(brushConfig, canvasRef, brushingAreaCanvasRef, cursorRef);

	return {
		clearBrushOverlayCanvasRef,
		captureMask,
		restoreMask,
	};
};
